import { $Q, $Qll } from "../utils/query-selector";

let imagePrincipal = null

export function captureMenu(){
  const menuWrapper = $Qll(".dropdown-wrapper-elements");
  imagePrincipal = $Q('.image-principal').src

  
  menuWrapper.forEach(element => {
    element.addEventListener('mouseover', (e) => {

      if ( e.target.tagName === 'A') {
        if ( e.target.dataset.menu != "none"){
          changeImg(e.target.dataset.menu);
        }
      }
    })
  });
}

function changeImg(dataSet){
  const imageMenu = $Q('.image-principal')

  imageMenu.src = dataSet

  updateMenu();
}

function updateMenu(){
  const menuWrapper = $Qll(".dropdown-wrapper-elements");
  
  menuWrapper.forEach(element => {
    element.addEventListener('mouseout', (e) => {

      if ( e.target.tagName === 'A') {
        if ( e.target.dataset.menu != "none"){
          updateImage(imagePrincipal)
        }
      }
    })
  });
}

function updateImage(imagePrincipal){
  const imageToUpdate = $Q('.image-principal')

  imageToUpdate.src = imagePrincipal

}